import { useContext } from 'react';
import { Nullable } from 'types';

import type { Funnel } from 'services/routes/locations/types';
import { FunnelContext, FunnelInfo } from 'services/contexts/FunnelContext';

export const useFunnel = (): {
  getFunnel: (funnel: Funnel) => Nullable<FunnelInfo>;
} => {
  const activeFunnels = useContext(FunnelContext);

  /** @returns Corresponding funnel from funnel context. */
  const getFunnel = (funnel: Funnel) => {
    for (let i = 0; i < activeFunnels.length; i += 1) {
      const info = activeFunnels[i];
      if (info.funnel === funnel) {
        return info;
      }
    }
    return null;
  };

  return {
    getFunnel,
  };
};
